import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, LingoApiResponse, Schemas, Space } from "@thenounproject/lingo-core";
import * as actionTypes from "../actions/actionTypes";

const { CALL_API } = API;

interface Args {
  spaceId: Space["id"];
}

export const fetchAssetViews = ({ spaceId }: Args) => {
  return {
    spaceId,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_ASSET_VIEWS,
        actionTypes.FETCH_ASSET_VIEWS_SUCCESS,
        actionTypes.FETCH_ASSET_VIEWS_FAILURE,
      ],
      endpoint: `spaces/${spaceId}/views`,
      method: "GET",
      schema: Schemas.ASSET_VIEW,
    },
  };
};

const useSavedViewsFetch = () => {
  const dispatch = useDispatch();
  return useCallback(
    (args: Args) => {
      return dispatch(fetchAssetViews(args)) as unknown as Promise<LingoApiResponse>;
    },
    [dispatch]
  );
};
export default useSavedViewsFetch;
